import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-employee',
  templateUrl: './employee.component.html',
  styleUrls: ['./employee.component.scss']
})
export class EmployeeComponent implements OnInit {
  isShownError: boolean = true;
  isShownSuccess: boolean = true;
  Status: boolean = false;
  ErrorMsg: string;
  SuccessMsg: string;
  StatusEmp: boolean = true;
  isShownSaveBtn: boolean = false;
  isShownUpdateBtn: boolean = true;
  isShownActive: Boolean = true;
  isShownActiveEmp: Boolean = true;

  searchText: string;
  EmployeeNum: string;
  EmployeeName: string;
  EmployeeEmail: string;
  EmployeePass: string;
  description: string;
  EditEmpId: string;
  Roles = [];
  RoleId: string;
  EditedEmp = [] as any;
  EmployeeExport = [] as any;

  vRead: string;
  vWrite: string;
  isShownWrite: boolean = true;

  displayedColumns: string[] = ['sno', 'employeeNo', 'employeeName', 'roleName', 'status'];
  dataSource: MatTableDataSource<any[]>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.vRead = localStorage.getItem('EmployeeRead');
    this.vWrite = localStorage.getItem('EmployeeWrite');
    if ((this.vRead == undefined || this.vRead == "") && (this.vWrite == undefined || this.vWrite == ""))
      window.location.href = '/Dashboard';
    if (this.vWrite != undefined && this.vWrite != "") {
      if (this.vWrite == "True")
        this.isShownWrite = false;
    }

    this.BindRoleDDL();
    this.BindEmployeeGrid();
    this.isShownActiveEmp = false;
    this.StatusEmp = true;
    this.BindExportExcel();
  }

  BindRoleDDL() {
    var value = this.http.get(environment.apiUrl + 'EmployeeAdm/GetRolesForDDL').toPromise().then(
      (data: any) => {
        debugger;
        if (data.length != 0) {
          debugger;
          this.Roles = data;
          this.RoleId = "0";
        }
        else {
          this.RoleId = "0";
        };
      });
  }
  BindEmployeeGrid() {
    var value = this.http.get(environment.apiUrl + 'EmployeeAdm/GetEmployeeForGrid').toPromise().then(
      (data: any) => {
        debugger;
        if (data.length != 0) {
          debugger;
          this.dataSource = new MatTableDataSource(data);
          this.dataSource.data = data;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;

        }
        else {

        };
      });
  }

  InsertEmployee() {
    debugger;
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    var vRoleId = this.RoleId;
    var vEmployeeNum = this.EmployeeNum;
    var vEmployeeName = this.EmployeeName;
    var vEmailId = this.EmployeeEmail;
    var vPass = this.EmployeePass;


    if (vEmployeeNum == undefined || vEmployeeNum == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter the Employee Number.";
      return false;
    }
    if (vEmployeeName == undefined || vEmployeeName == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter the Employee Name.";
      return false;
    }
    if (vRoleId == undefined || vRoleId == "" || vRoleId == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please select Anyone Role.";
      return false;
    }
    if (vEmailId == undefined || vEmailId == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter the EmailId.";
      return false;
    }
    if (vEmailId != undefined && vEmailId != "") {
      //<--Email Validation-->
      var regEmail = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

      if (regEmail.test(vEmailId) == false) {
        this.isShownError = false;
        this.ErrorMsg = 'EmailID is not valid';
        return false;

      }
    }
    if (vPass == undefined || vPass == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter the Password.";
      return false;
    }

    var vStatus = "Active";
    if (this.StatusEmp == true)
      vStatus = "Active";
    else
      vStatus = "InActive";

    if (this.description == undefined)
      this.description = "";

    let params = new HttpParams();
    params = params.append('sRoleId', this.RoleId);
    params = params.append('sEmployeeNo', this.EmployeeNum);
    params = params.append('sEmployeeName', this.EmployeeName);
    params = params.append('sEmail', this.EmployeeEmail);
    params = params.append('sPass', this.EmployeePass);
    params = params.append('sStatusLogin', vStatus);
    params = params.append('sDescription', this.description);

    var value = this.http.get(environment.apiUrl + 'EmployeeAdm/InsertEmployee', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var Custnotfy = data;
        this.RoleId = "0";
        this.EmployeeNum = "";
        this.EmployeeName = "";
        this.description = "";
        this.EmployeeEmail = "";
        this.EmployeePass = "";
        this.StatusEmp = true;

        this.SuccessMsg = "Employee Added.";
        this.BindEmployeeGrid();
        return false;
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Insert Failed, Please Try Again.";
          return false;
        }
        else if (vErrorMsg1 == "Exist") {
          this.isShownError = false;
          this.ErrorMsg = "Employee Code Already Exist.";
          return false;
        }
        else {
        }
      });

  }

  EditEmployee(item: any) {
    debugger;
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";

    this.isShownSaveBtn = true;
    this.isShownUpdateBtn = false;
    this.isShownActive = false;
    this.isShownActiveEmp = false;
    this.EditedEmp = item;
    var vEmpNum = this.EditedEmp.employeeNo;
    var vEmpName = this.EditedEmp.employeeName;
    var vEmail = this.EditedEmp.emailId;
    var vPass = this.EditedEmp.password;
    var vdescription = this.EditedEmp.description;
    var vRoleId = this.EditedEmp.roleId;
    var vStatus = this.EditedEmp.status;
    var vLoginStatus = this.EditedEmp.loginStatus;
    this.EditEmpId = this.EditedEmp.employeeId;

    this.EmployeeNum = vEmpNum;
    this.EmployeeName = vEmpName;
    this.EmployeeEmail = vEmail;
    this.EmployeePass = vPass;
    this.description = vdescription;
    this.RoleId = vRoleId;

    if (vStatus == "Active")
      this.Status = false;
    else
      this.Status = true;

    if (vLoginStatus == "Active")
      this.StatusEmp = true;
    else
      this.StatusEmp = false;
  }
  UpdateEmployee() {
    debugger;
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    var vRoleId = this.RoleId;
    var vEmployeeNum = this.EmployeeNum;
    var vEmployeeName = this.EmployeeName;
    var vEmailId = this.EmployeeEmail;
    var vPass = this.EmployeePass;


    if (vEmployeeNum == undefined || vEmployeeNum == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter the Employee Number.";
      return false;
    }
    if (vEmployeeName == undefined || vEmployeeName == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter the Employee Name.";
      return false;
    }
    if (vRoleId == undefined || vRoleId == "" || vRoleId == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please select Anyone Role.";
      return false;
    }
    if (vEmailId == undefined || vEmailId == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter the EmailId.";
      return false;
    }
    if (vEmailId != undefined && vEmailId != "") {
      //<--Email Validation-->
      var regEmail = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

      if (regEmail.test(vEmailId) == false) {
        this.isShownError = false;
        this.ErrorMsg = 'EmailID is not valid';
        return false;

      }
    }
    if (vPass == undefined || vPass == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter the Password.";
      return false;
    }

    var vStatusEmp = "Active";
    if (this.StatusEmp == true)
      vStatusEmp = "Active";
    else
      vStatusEmp = "InActive";

    var vStatus = "Active";
    if (this.Status == true)
      vStatus = "InActive";
    else
      vStatus = "Active";

    if (this.description == undefined)
      this.description = "";

    let params = new HttpParams();
    params = params.append('sRoleId', this.RoleId);
    params = params.append('sEmployeeNo', this.EmployeeNum);
    params = params.append('sEmployeeName', this.EmployeeName);
    params = params.append('sEmail', this.EmployeeEmail);
    params = params.append('sPass', this.EmployeePass);
    params = params.append('sStatusLogin', vStatusEmp);
    params = params.append('sDescription', this.description);
    params = params.append('sStatus', vStatus);
    params = params.append('sEmpId', this.EditEmpId);

    var value = this.http.get(environment.apiUrl + 'EmployeeAdm/UpdateEmployee', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var Custnotfy = data;
        this.RoleId = "0";
        this.EmployeeNum = "";
        this.EmployeeName = "";
        this.description = "";
        this.EmployeeEmail = "";
        this.EmployeePass = "";
        this.StatusEmp = true;

        this.SuccessMsg = "Employee Updated.";
        this.BindEmployeeGrid();

        this.StatusEmp = true;
        this.isShownSaveBtn = false;
        this.isShownUpdateBtn = true;
        this.isShownActive = true;
        this.isShownActiveEmp = false;
        return false;
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Updated Failed, Please Try Again.";
          return false;
        }
        else {
        }
      });

  }
  ClearEmployee() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";

    this.RoleId = "0";
    this.EmployeeNum = "";
    this.EmployeeName = "";
    this.description = "";
    this.EmployeeEmail = "";
    this.EmployeePass = "";
    this.StatusEmp = true;
    this.isShownSaveBtn = false;
    this.isShownUpdateBtn = true;
    this.isShownActive = true;
    this.isShownActiveEmp = false;
  }

  BindExportExcel() {
    var value = this.http.get(environment.apiUrl + 'EmployeeAdm/GetEmployeeForExport').toPromise().then(
      (data: any) => {
        this.EmployeeExport = data;
      });
  }

  applyFilter(filterValue: string) {
    debugger;
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }
  exportexcel(): void {
    debugger;
    /* table id is passed over here */
    const workSheet = XLSX.utils.json_to_sheet(this.EmployeeExport);
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, workSheet, 'Employee');

    /* save to file */
    XLSX.writeFile(wb, "Employee.xlsx");

  }

  viewPassword() {
    debugger;
    if ((document.getElementById('txtpassword') as HTMLInputElement).type == 'password') {
      (document.getElementById('txtpassword') as HTMLInputElement).type = 'text';
      (document.getElementById('pass-signstatus') as HTMLInputElement).className = 'fa fa-eye-slash';
    }
    else {
      (document.getElementById('txtpassword') as HTMLInputElement).type = 'password';
      (document.getElementById('pass-signstatus') as HTMLInputElement).className = 'fa fa-eye';
    }

  }
}
